@if (job(); as job) {
  <nz-card class="general-info-card" [nzBordered]="false">
    <div class="card-body">

      <!-- Left: Job details -->
      <div class="job-info">
        <div class="job-name">{{ job.name }}</div>
        
        <div class="job-comments">
          @if (job.comments) {
            <nz-icon nzType="message" nzTheme="outline" class="comments-icon"></nz-icon>
            {{ job.comments }}
          } @else {
            <nz-icon nzType="dash" nzTheme="outline" class="comments-icon no-comments-icon"></nz-icon>
            <span class="no-comments">No comments</span>
          }
        </div>

        <div class="meta-row">
          <nz-icon nzType="project" nzTheme="outline" class="meta-icon"></nz-icon>
          <span class="meta-label">Project</span>
          <span class="meta-value">{{ job.projectName }}</span>

          <nz-divider nzType="vertical" />

          <nz-icon nzType="calendar" nzTheme="outline" class="meta-icon"></nz-icon>
          <span class="meta-label">Created</span>
          <span class="meta-value">{{ job.createdDate | date: 'dd MMM yyyy' }}</span>
        </div>
      </div>

      <nz-divider nzType="vertical" class="section-divider"></nz-divider>

      <!-- Right: Cost stats -->
      <div class="cost-stats">
        <div class="stats-row">

          <div class="stat-item">
            <div class="stat-label">Iteration Cost</div>
            @if (iterationCost() !== null) {
              <div class="stat-value">${{ iterationCost().toFixed(2) }}</div>
            } @else {
              <div class="stat-value stat-empty">—</div>
            }
          </div>

          <div class="stat-separator"></div>

          <div class="stat-item">
            <div class="stat-label">Run Cost</div>
            @if (job.run_cost) {
              <div class="stat-value">${{ job.run_cost.toFixed(2) }}</div>
            } @else {
              <div class="stat-value stat-empty">—</div>
            }
          </div>

        </div>

        @if (costType()) {
          <div class="cost-type-row">
            <nz-tag [nzColor]="costTypeColor()" class="cost-type-tag">
              <span nz-icon nzType="info-circle" nzTheme="outline"></span>
              {{ costType() }}
            </nz-tag>
          </div>
        }
      </div>
    </div>
  </nz-card>
}

<!-- Equation card -->
<!-- @let global = runfileParams.value()?.global;
<nz-card class="equation-card" [nzBordered]="false">

  <div class="eq-header">
    <nz-icon nzType="experiment" nzTheme="outline" class="eq-header-icon"></nz-icon>
    <span class="eq-heading">Equation</span>
  </div>
  <nz-spin [nzSpinning]="runfileParams.isLoading()">
      <div class="eq-params">

        <div class="eq-param">
          <span class="eq-label">Kernel</span>
          <span class="eq-value">{{ global?.['Kernel']?.value ?? '—' | titlecase }}</span>
        </div>
  
        <div class="eq-divider"></div>
  
        <div class="eq-param">
          <span class="eq-label">Equation</span>
          <span class="eq-value">{{ global?.['Equation']?.value ?? '—' | titlecase }}</span>
        </div>
  
        <div class="eq-divider"></div>
  
        <div class="eq-param">
          <span class="eq-label">Problem</span>
          <span class="eq-value">{{ global?.['Problem']?.value ?? '—' | titlecase}}</span>
        </div>  
      </div>
  </nz-spin>

</nz-card> -->

<nz-card class="logs-card">
    <app-output-logs />
</nz-card>


